function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#1E4498",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15.88 6.072L12 1 8.12 6.072c-2.929 3.83-4.086 5.55-4.086 8.12 0 2.178.562 3.234 2.604 4.714L12 22.787l5.362-3.88c2.042-1.481 2.604-2.537 2.604-4.716 0-2.57-1.157-4.289-4.085-8.119zm-5.07 12.596l-.035 1.055c0 .137-.085.154-.17.086-1.395-1.005-3.03-2.196-3.03-2.196-1.702-1.226-1.804-2.553-1.804-3.456 0-.612.085-1.276.375-1.957.017-.051.05-.136.102-.136.034 0 .05.017.068.05.596.869 1.549 2.282 2.502 3.44 1.838 2.212 2.026 2.025 1.992 3.114zM12 16.677c-.017 0-.034-.017-.051-.017L8.187 12.2c-.425-.51-.664-1.072-.664-1.634 0-.375.137-.766.409-1.123l4.017-5.515c.017-.017.034-.034.051-.034.017 0 .034.017.051.034l4.017 5.515c.255.357.409.748.409 1.123 0 .562-.222 1.123-.664 1.634l-3.762 4.46c-.017.017-.034.017-.051.017zm4.426.936s-1.652 1.191-3.03 2.196c-.085.068-.153.05-.17-.086l-.035-1.055c-.034-1.09.154-.902 1.992-3.115.953-1.157 1.906-2.553 2.502-3.438.017-.034.051-.051.068-.051.034 0 .085.085.102.136.273.68.375 1.345.375 1.957 0 .903-.102 2.23-1.804 3.456z"
}));

var SvgIcBualuang = function SvgIcBualuang(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBualuang, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_bualuang.fa13d358.svg";
export { ForwardRef as ReactComponent };